module.exports = __webpack_public_path__ + "img/shiba-loading.a357aec3.png";